<template>
    <input class="slider"
           type="range"
           :min="min"
           :max="max"
           :value="value"
           :step="step"
           @input="$emit('input', $event.target.value)"
           :style="'background-image: -webkit-gradient(linear, 0% 0%, 100% 0%, color-stop('+
         percent+', ' + filledRail +'), color-stop('+ percent+', '+ emptyRail +'));'">
</template>

<script>
export default {
    name: "Slider",
    props: {
        value: {
            required: true
        },
        min: {
            required: true
        },
        max: {
            required: true
        },
        step: {
            required: true
        },
        filledRail: {
            type: String,
            required: true,
        },
        emptyRail: {
            type: String,
            required: true
        }
    },
    computed: {
        percent() {
            return (this.value - this.min) / (this.max - this.min)
        }
    },
}
</script>

<style scoped>

</style>